import React from 'react';
import { motion } from 'framer-motion';
import BillingSection from './bilingSection';
import BrokerageDetails from './brokerageDetails';
import UserInfo from './userInfoTab';

export default function TabContent({ activeTab, userData, tokenId }) {
  const renderTabContent = () => {
    switch (activeTab) {
      case "userInfo":
        return <UserInfo userData={userData} tokenId={tokenId} />;
      case "help":
        return <div className="hover:text-[#0062ff]"><a href="https://medium.com/@usedeli/help-with-navigating-deli-a0dbaf99aba3">Help Content</a></div>;
      case "brokerage":
        return <BrokerageDetails />;
      case "billing":
        return <BillingSection />;
      default:
        return <div>Select a tab</div>;
    }
  };

  return (
    <div className="w-full p-4 bg-white">
      <motion.div
        key={activeTab}
        initial={{ opacity: 0, x: 20 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -20 }}
        transition={{ duration: 0.3 }}
      >
        {renderTabContent()}
      </motion.div>
    </div>
  );
}
